import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  access_token: null,
  refresh_token: null,
  role: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { user, access_token, refresh_token, role } = action.payload;
      state.user = user;
      state.access_token = access_token;
      state.refresh_token = refresh_token;
      state.role = role || user?.user_type || user?.role;
      state.isLoggedIn = true;
    },

    logout: (state) => {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      state.role = null;
      state.isLoggedIn = false;
    },

    updateUser: (state, action) => {
      const prev = state.user || {};
      const next = action.payload || {};
      const merged = { ...prev, ...next };

      // Never wipe a known profile photo with null/empty from a partial API payload
      const prevImage =
        prev.profileImageUrl ||
        prev.profile_pic ||
        prev.avatar_image ||
        (prev.avatar && typeof prev.avatar === "object" ? prev.avatar.image : "") ||
        "";
      const nextImage =
        next.profileImageUrl ||
        next.profile_pic ||
        next.avatar_image ||
        (next.avatar && typeof next.avatar === "object" ? next.avatar.image : "") ||
        "";

      const image = nextImage || prevImage || "";
      if (image) {
        merged.profile_pic = image;
        merged.profileImageUrl = image;
      }

      state.user = merged;
    },

    updateTokens: (state, action) => {
      if (action.payload.access_token) {
        state.access_token = action.payload.access_token;
      }
      if (action.payload.refresh_token) {
        state.refresh_token = action.payload.refresh_token;
      }
    },
  },
});

export const { loginSuccess, logout, updateUser, updateTokens } =
  authSlice.actions;
export default authSlice.reducer;
